import { atom } from "jotai";
import { ZoomRemoteDataDelegator } from "../room/participant/media/RemoteDataDelegator";

export const ZoomRemoteDataDelegatorAtom = atom<ZoomRemoteDataDelegator | null>(
  null,
);
